import * as React from "react";
import { useDrawer, Link } from "@grandvisionhq/common";
const PrescriptionFormLabelDetailsTrigger = ({ title, onClick }) => {
  const { toggle } = useDrawer();
  const handleClick = () => {
    toggle();
    onClick();
  };
  return /* @__PURE__ */ React.createElement(
    Link,
    {
      isVisualOnly: true,
      label: title,
      onClick: handleClick,
      "data-t": "prescription-form-drawer-trigger"
    }
  );
};
export {
  PrescriptionFormLabelDetailsTrigger
};
//# sourceMappingURL=PrescriptionFormLabelDetailsTrigger.js.map
